var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 19.1663C4.93731 19.1663 0.833252 15.0623 0.833252 9.99967C0.833252 4.93706 4.93731 0.833008 9.99992 0.833008C15.0625 0.833008 19.1666 4.93706 19.1666 9.99967C19.1666 15.0623 15.0625 19.1663 9.99992 19.1663ZM16.1662 14.2702C17.0071 13.0583 17.4999 11.5865 17.4999 9.99967C17.4999 5.85754 14.1421 2.49967 9.99992 2.49967C5.85778 2.49967 2.49992 5.85754 2.49992 9.99967C2.49992 11.5865 2.99274 13.0583 3.83367 14.2702C4.77155 13.0314 6.97542 12.4997 9.99992 12.4997C13.0244 12.4997 15.2283 13.0314 16.1662 14.2702ZM14.9705 15.6161C14.7266 14.7391 12.9744 14.1663 9.99992 14.1663C7.02544 14.1663 5.27326 14.7391 5.02935 15.6161C6.35267 16.7882 8.0932 17.4997 9.99992 17.4997C11.9066 17.4997 13.6472 16.7882 14.9705 15.6161ZM9.99992 4.99967C7.9825 4.99967 6.66658 6.46281 6.66658 8.33301C6.66658 11.1892 8.13397 12.4997 9.99992 12.4997C11.8483 12.4997 13.3333 11.2327 13.3333 8.49967C13.3333 6.60099 12.0117 4.99967 9.99992 4.99967ZM8.33325 8.33301C8.33325 10.2241 9.01509 10.833 9.99992 10.833C10.9813 10.833 11.6666 10.2483 11.6666 8.49967C11.6666 7.45836 11.013 6.66634 9.99992 6.66634C8.9447 6.66634 8.33325 7.34619 8.33325 8.33301Z",
    fill: "#2B391C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9d2228e7116c9c1ac50a28a16d1c4561.svg";
export { ForwardRef as ReactComponent };